const TOKEN_KEY = 'tt-signage-deviceToken';
const COMPANY_ID_KEY = 'tt-signage-companyId';
const COMPANY_NAME_KEY = 'tt-signage-companyName';
const OFFICE_ID_KEY = 'tt-signage-officeId';
const OFFICE_LABEL_KEY = 'tt-signage-officeLabel';
const FLOOR_ID_KEY = 'tt-signage-floorId';
const VIEW_KEY = 'tt-signage-view';

export type SignageViewMode = 'map' | 'office' | 'outOfOffice' | 'workingElsewhere';

const VIEW_MODES: SignageViewMode[] = ['map', 'office', 'outOfOffice', 'workingElsewhere'];

export interface SignageSession {
  deviceToken: string;
  companyId: string;
  companyName: string;
  officeId: number;
  officeLabel: string;
}

export function loadSignageSession(): SignageSession | null {
  const deviceToken = window.localStorage.getItem(TOKEN_KEY);
  const companyId = window.localStorage.getItem(COMPANY_ID_KEY);
  const officeIdRaw = window.localStorage.getItem(OFFICE_ID_KEY);
  if (!deviceToken || !companyId || !officeIdRaw) return null;
  const officeId = Number(officeIdRaw);
  if (Number.isNaN(officeId)) return null;
  return {
    deviceToken,
    companyId,
    companyName: window.localStorage.getItem(COMPANY_NAME_KEY) ?? '',
    officeId,
    officeLabel: window.localStorage.getItem(OFFICE_LABEL_KEY) ?? '',
  };
}

export function saveSignageSession(session: SignageSession): void {
  window.localStorage.setItem(TOKEN_KEY, session.deviceToken);
  window.localStorage.setItem(COMPANY_ID_KEY, session.companyId);
  window.localStorage.setItem(COMPANY_NAME_KEY, session.companyName);
  window.localStorage.setItem(OFFICE_ID_KEY, String(session.officeId));
  window.localStorage.setItem(OFFICE_LABEL_KEY, session.officeLabel);
}

export function clearSignageSession(): void {
  window.localStorage.removeItem(TOKEN_KEY);
  window.localStorage.removeItem(COMPANY_ID_KEY);
  window.localStorage.removeItem(COMPANY_NAME_KEY);
  window.localStorage.removeItem(OFFICE_ID_KEY);
  window.localStorage.removeItem(OFFICE_LABEL_KEY);
  window.localStorage.removeItem(FLOOR_ID_KEY);
  window.localStorage.removeItem(VIEW_KEY);
}

export function getSignageToken(): string | null {
  return window.localStorage.getItem(TOKEN_KEY);
}

// A rebooted screen comes back on the floor it was showing.
export function loadSelectedFloorId(): number | null {
  const raw = window.localStorage.getItem(FLOOR_ID_KEY);
  if (!raw) return null;
  const floorId = Number(raw);
  return Number.isNaN(floorId) ? null : floorId;
}

export function saveSelectedFloorId(floorId: number): void {
  window.localStorage.setItem(FLOOR_ID_KEY, String(floorId));
}

// Likewise the board it was showing, so the nightly reload doesn't drop a
// screen set to one of the lists back to the map.
export function loadSignageView(): SignageViewMode {
  const stored = window.localStorage.getItem(VIEW_KEY);
  return VIEW_MODES.find(mode => mode === stored) ?? 'map';
}

export function saveSignageView(view: SignageViewMode): void {
  window.localStorage.setItem(VIEW_KEY, view);
}
